import React from "react";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";

export default function FormRadio(props) {
  const { value, setValue, label, options, type } = props;

  const handleChange = (event) => {
    type !== "search"
      ? setValue({
          value: event.target.value,
          label: event.target.value === true ? "True" : "False",
        })
      : setValue({
          value: event.target.value,
          label:
            event.target.value === "DATE_UPDATED"
              ? "Updated Date"
              : "Created Date",
        });
  };

  return (
    <FormControl>
      <FormLabel
        id="demo-controlled-radio-buttons-group"
        style={{ fontSize: "18px" }}
      >
        {label}
      </FormLabel>
      <RadioGroup
        aria-labelledby="demo-controlled-radio-buttons-group"
        name="controlled-radio-buttons-group"
        value={value.value}
        onChange={handleChange}
        //
      >
        <div
          style={{ display: "flex", gap: type === "search" ? "2rem" : "15rem" }}
        >
          {options.map((item) => (
            <div style={{ display: "flex" }}>
              <FormControlLabel value={item.value} control={<Radio />} />
              <p style={{ color: "#000" }}>{item.label}</p>
            </div>
          ))}
        </div>
      </RadioGroup>
    </FormControl>
  );
}
